import { mapState, mapMutations, mapGetters } from 'vuex';
import store from '@/store/store';
import PhoneInput from '@/components/inputs/PhoneInput/PhoneInput.vue';
import DadataInput from '@/components/inputs/DadataInput/DadataInput.vue';
import TutorialModal from '@/components/ui/modals/TutorialModal/TutorialModal.vue';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, max } from 'vee-validate/dist/rules';
import url from '@/validators/url.validator';
import phone from '@/validators/phone.validator';
import config from '@/config';

export default {
  data() {
    return {
      password: {
        currentPassword: null,
        newPassword: null,
        newPasswordConfirm: null
      }
    };
  },

  beforeRouteEnter(to, from, next) {
    const { id: firmId, isAdmin } = store.state.user.profile;

    if (!isAdmin) {
      store.commit('startLoad');
      store.dispatch('firmInfo', firmId).then(() => {
        store.commit('endLoad');
        next();
      });
    } else {
      next();
    }
  },

  beforeRouteUpdate(to, from, next) {
    const { id: firmId, isAdmin } = this.$store.state.user.profile;
    console.log(isAdmin);
    this.$store.commit('startLoad');
    if (!isAdmin) {
      this.$store.dispatch('firmInfo', firmId).then(() => {
        this.$store.commit('endLoad');
        next();
      });
    } else {
      this.$store.commit('endLoad');
      next();
    }
  },

  computed: {
    supportEmail: () => config.supportEmail,
    ...mapState({
      profile: state => state.user.profile,
      timezones: state => state.timezones.timezones,
      isAdmin: state => state.user.profile.isAdmin,
      firm: state => state.firm.info,
      passwordUpdating: state => state.firm.passwordUpdating
    }),

    ...mapGetters(['getFirmInfo'])
  },

  methods: {
    ...mapMutations(['startLoad', 'endLoad']),

    updateGeneralInfo() {
      return this.$refs.generalForm.validate().then(success => {
        if (!success) {
          this.flashError('Проверьте все поля формы');
          return;
        }

        const updateInfoPromise = this.$store.dispatch('updateFirmInfo', {
          firmId: this.$store.state.user.profile.id,
          firmData: {
            name: this.firm.name,
            contact_person: this.firm.contact_person,
            contact_phone: this.firm.contact_phone,
            contact_email: this.firm.contact_email,
            website: this.firm.website,
            country: this.firm.country,
            region: this.firm.region,
            city: this.firm.city,
            address: 'no data' // HACK
          }
        });

        updateInfoPromise
          .then(() => {
            this.flashSuccess('Информация о компании обновлена.');
          })
          .catch(() => {
            this.flashError('Что-то пошло не так. Попробуйте еще раз.');
          });

        return updateInfoPromise;
      });
    },

    validatePhone(e) {
      this.firm.contact_phone = e;
      this.$refs.phoneProvider.syncValue(e);
      this.$refs.phoneProvider.validate();
    },

    validateRegion(e) {
      const value = e.value ? e.value : '';
      this.firm.region = value;
      this.$refs.regionProvider.syncValue(value);
      this.$refs.regionProvider.validate();
    },

    validateCity(e) {
      const value = e.value ? e.value : '';
      this.firm.city = value;
      this.$refs.cityProvider.syncValue(value);
      this.$refs.cityProvider.validate();
    },

    updatePassword() {
      return this.$refs.passwordForm.validate().then(success => {
        if (!success) {
          this.flashError('Проверьте все поля формы');
          return;
        }

        const { newPassword, currentPassword } = this.password;
        const updatePasswordPromise = this.$store.dispatch('updatePassword', {
          currentPassword,
          newPassword
        });
        updatePasswordPromise
          .then(() => {
            this.flashSuccess('Пароль изменен');
            this.$refs.passwordForm.reset();
          })
          .catch(() => {
            this.flashError(
              'Старый пароль введен не верно. Попробуйте еще раз'
            );
          });
        return updatePasswordPromise;
      });
    }
  },

  components: {
    ValidationProvider,
    ValidationObserver,
    PhoneInput,
    DadataInput,
    TutorialModal
  }
};

// Validation rules
extend('url', {
  validate: url,
  message: 'Укажите корректный url-адрес'
});

extend('max-url', {
  ...max,
  message: 'Не более 50 символов'
});

extend('phone', {
  validate: phone,
  message: 'Укажите телефон в формате 8 (ХХХ) ХХХ-ХХ-ХХ'
});

extend('required', {
  ...required,
  message: 'Обязательно'
});

extend('password', {
  params: ['target'],
  validate(value, { target }) {
    return value === target;
  },
  message: 'Пароли не совпадают'
});
